import { useEffect } from "react";
import { LegCreateForm } from "./Form";
import { useGetDriversQuery } from "../../../../redux/services/drivers/driversApi";
import { IClient, ILeg, IUser } from "../../../../types";

// Driver option interface for select components
interface DriverOption {
  label: string;
  value: IUser;
}

// Form initialization options interface
interface FormInitOptions {
  setErrors?: boolean;
  reset?: boolean;
}

// LegCreate component props interface
export interface LegCreateProps {
  errors?: Record<string, string>;
  client?: IClient;
  job?: any; // Add job prop
  form: any;
  updateForm: (data: any) => void;
  setFormInit: (
    initData: Record<string, any>,
    options?: FormInitOptions
  ) => void;
  // Additional props that might be passed through
  remove?: any;
  id?: any;
  formData?: Record<string, any>;
  data?: Record<string, any>;
  renderId?: (id: any) => any;
  renderValue?: (valueId: string) => any;
  locationOptions?: any[];
  addForm?: any;
  formId?: any;
  title?: string;
  jobCreate?: boolean;
  jobCreateLayout?: boolean;
  toggleHandoff?: any;
  hideHeader?: boolean;
  size?: "sm" | "md" | "lg";
  onMileageUpdate?: any;
}

// Drivers API response interface
interface DriversApiResponse {
  drivers: IUser[];
  pagination?: {
    page: number;
    limit: number;
    totalPages: number;
    totalCount: number;
  };
}

export const LegCreate: React.FC<LegCreateProps> = ({
  errors = {},
  client,
  job,
  form,
  updateForm,
  setFormInit,
  ...props
}) => {
  // Set initial client context once when the modal opens — avoid re-init on every
  // parent re-render (DispatchLayout leg form updates re-render the whole tree).
  useEffect(() => {
    if (!client) return;

    const init: Record<string, any> = {};
    const clientId = client._id || client.id;

    if (clientId && form.client?._id !== clientId && form.client?.id !== clientId) {
      init.client = client;
    }

    if (!form.appointmentDate) {
      init.appointmentDate = form.job?.transactionDate || null;
    }

    if (Object.keys(init).length > 0) {
      setFormInit(init);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client?._id, client?.id]);

  /*
    Fetch Drivers
  */
  const {
    data: drivers,
    isLoading,
    isFetching,
  } = useGetDriversQuery({
    page: 1,
    limit: 100,
  });

  /*
    Render Driver Options
  */
  const driverOptions: DriverOption[] =
    isLoading || isFetching
      ? []
      : (drivers as DriversApiResponse)?.drivers?.map((driver: IUser) => ({
          label: driver.fullName || "",
          value: driver,
        })) || [];

  /*
    Set form helper
  */
  function setForm(obj: Record<string, any>, custom?: boolean): void {
    setFormInit(custom ? obj : {}, { setErrors: true, reset: true });
    return;
  }

  return (
    <LegCreateForm
      handleChange={updateForm}
      errors={errors}
      form={form}
      driverOptions={driverOptions}
      setForm={setForm}
      job={job}
      // Provide default values for required props that might not be passed
      remove={props.remove}
      id={props.id}
      renderValue={props.renderValue || (() => undefined)}
      addForm={props.addForm || (() => {})}
      formData={props.formData || {}}
      data={props.data || {}}
      renderId={props.renderId || ((id: any) => id)}
      locationOptions={props.locationOptions || []}
      formId={props.formId}
      title={props.title}
      jobCreate={props.jobCreate}
      jobCreateLayout={props.jobCreateLayout}
      toggleHandoff={props.toggleHandoff}
      hideHeader={props.hideHeader}
      size={props.size}
      onMileageUpdate={props.onMileageUpdate || (() => {})}
    />
  );
};

export default LegCreate;
